import { AnyIfEmpty } from "react-redux";
import { GET_MANAGEMENT_LIST_FAILURE, GET_MANAGEMENT_LIST_REQUEST, GET_MANAGEMENT_LIST_SUCCESS } from "../constants/userManagement.constants";
import axios from "axios";
import { UserDetailsProps } from "../../../components/userManagement/UserManageMentDetails";


const userManagementListRequest = () => {
    return {
        type: GET_MANAGEMENT_LIST_REQUEST,
    };
};

const userManagementListSuccess = (list: AnyIfEmpty<object>) => {
    return {
        type: GET_MANAGEMENT_LIST_SUCCESS,
        payload: list,
    };
};

const userManagementListfailure = (listError: string) => {
    return {
        type: GET_MANAGEMENT_LIST_FAILURE,
        payload: listError,
    };
};

export const getUserManagementList = (page: number, searchText: string, requestType: string, limit: number) => {
    return (dispatch: (arg: { type: string; payload?: string; }) => void) => {
        dispatch(userManagementListRequest());
        axios
            .get(`/user-admin/visitors-requests-list`, {
                params: {
                    searchText: searchText,
                    page: page,
                    limit: limit,
                    requestType: requestType
                }
            })
            .then((response) => {

                if (response?.data?.statusCode === 200)
                    dispatch(userManagementListSuccess(response.data))
                else
                    dispatch(userManagementListfailure(response?.data?.message))
            }).catch((err) => dispatch(userManagementListfailure(err)));
    };
};

export const getUserDetails = (id: string, onSuccess?: (userDetails: UserDetailsProps) => void, onFailure?: () => void) => {
    return (dispatch: (arg: { type: string; payload?: string; }) => void) => {
        dispatch(userManagementListRequest());
        axios
            .get(`/user-admin/${id}`)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    const responseData = response?.data?.data
                    const userDetails: UserDetailsProps = {
                        contact: responseData?.phoneNumber,
                        firstName: responseData?.firstName,
                        lastName: responseData?.lastName,
                        reason: responseData?.deleteAccountReason || '',
                        requestType: responseData?.activateRequestDate && responseData?.activateDate === null ? 'Activate Account' : responseData?.deActivateRequestDate && responseData?.deActivateDate === null && 'Deactivate Account',
                        countryCode: responseData?.countryCode || '',
                        email: responseData?.email,
                        actionDate: (responseData?.activateRequestDate && responseData?.activateDate === null) ? responseData?.activateDate : (responseData?.deActivateRequestDate && responseData?.deActivateDate === null) && responseData?.deActivateDate || null
                    }
                    onSuccess && onSuccess(userDetails)
                } else {
                    onFailure?.();
                }

            }).catch(() => {
                onFailure?.()
            });
    };
};

export const deactivateUser = (id: string, onSuccess?: (message: string) => void, onFailure?: (message: string) => void) => {
    return (dispatch: (arg: { type: string; payload?: string; }) => void) => {
        dispatch(userManagementListRequest());
        axios
            .patch(`/user-admin/deactivate/${id}`)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    onSuccess && onSuccess(response?.data?.message)
                } else {
                    onFailure?.(response?.data?.message);
                }
            }).catch((err) => {
                onFailure?.(err?.response?.data?.message)
            });
    };
};

export const activateUser = (id: string, onSuccess?: (message: string) => void, onFailure?: (message: string) => void) => {
    return (dispatch: (arg: { type: string; payload?: string; }) => void) => {
        dispatch(userManagementListRequest());
        axios
            .patch(`/user-admin/activate/${id}`)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    onSuccess && onSuccess(response?.data?.message)
                } else {
                    onFailure?.(response?.data?.message);
                }
            }).catch((err) => {
                onFailure?.(err?.response?.data?.message)
            });
    };
};